<template>
  <div v-if="funcao === 'padrao' || funcao === 'pesquisa-global'" class="row mx-1 my-3">
    <div class="col col-12">
      <div ref="toolbarContainer" class="toolbar-botoes d-flex align-items-center" :class="toolbarClasses">

        <!-- Botões Visíveis -->
        <template v-for="(button, index) in visibleButtons" :key="button.id">
          <div class="btn-group-custom d-flex align-items-center" :class="groupDirectionClass">
            <span class="d-inline-block toolbar-button-wrapper" tabindex="0" data-bs-dismiss="click" data-bs-toggle="tooltip2" data-bs-placement="top" :title="button.title">
              <button 
                class="btn btn-icon btn-light-primary me-2 position-relative" 
                :disabled="button.disabled" 
                @click="handleButtonClick(button.action)" 
                onclick="this.blur()">
                <span class="svg-icon svg-icon-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" v-html="getIconSvg(button.icon)"></svg>
                </span>
                <span v-if="button.badge" class="position-absolute translate-middle badge badge-circle badge-danger" style="top: 30%; left: 85%">{{ button.badge }}</span>
              </button>
            </span>
          </div>
          <div v-if="button.showSeparatorAfter" class="toolbar-separator"></div>
        </template>

        <!-- Botão de Overflow -->
        <div v-if="hasOverflow" class="btn-group dropdown" :class="groupDirectionClass">
          <button 
            ref="overflowButton"
            class="btn btn-icon btn-light-primary me-2 overflow-trigger" 
            type="button"
            @click.stop="toggleDropdown">
            <span class="svg-icon svg-icon-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
              </svg>
            </span>
          </button>
          <ul 
            ref="dropdownMenu" 
            class="dropdown-menu"
            :style="dropdownMenuStyle">
            <li 
              v-for="button in overflowButtons" 
              :key="button.id">
              <a 
                href="#" 
                class="dropdown-item d-flex align-items-center" 
                :class="{ 'disabled': button.disabled, 'border-bottom': button.showSeparatorAfter }"
                @click.prevent="button.disabled || handleButtonClick(button.action)">
                <span class="svg-icon svg-icon-2 me-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" v-html="getIconSvg(button.icon)"></svg>
                </span>
                <span>{{ button.title }}</span>
                <span v-if="button.badge" class="badge badge-circle badge-danger ms-auto">{{ button.badge }}</span>
              </a>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiretorioListToolbar",
  props: {
    instancia: {
      type: String,
      required: true
    },
    funcao: {
      type: String,
      default: 'padrao'
    },
    appTipo: {
      type: String,
      default: 'web'
    },
    tipo: {
      type: String,
      default: 'local'
    },
    view: {
      type: String,
      default: 'diretorio'
    },
    diretorioAtual: String,
    diretorioExcluidoRoot: String,
    selecionadosQtd: {
      type: Number,
      default: 0
    },
    isSelecionadoArquivo: Boolean,
    clipboardVazio: Boolean,
    copiarQtd: {
      type: Number,
      default: 0
    },
    recortarQtd: {
      type: Number,
      default: 0
    },
    itensTotal: {
      type: Number,
      default: 0
    },
    tipoUsuario: {
      type: String,
      default: 'usuarioNuvem'
    }
  },
  emits: [
    'transferir',
    'abrir-filtro',
    'abrir-procurar', 
    'propriedades',
    'restaurar',
    'nova-pasta',
    'excluir',
    'excluir-permanente',
    'renomear',
    'recortar',
    'copiar',
    'colar',
    'abrir-local',
    'abrir-arquivo',
    'atualizar',
    'pasta-acima',
    'pasta-anterior',
    'upload',
    'download',
    'link',
    'exportar'
  ],
  data() {
    return {
      visibleButtons: [],
      overflowButtons: [],
      hasOverflow: false,
      resizeObserver: null,
      debounceTimer: null,
      isCalculating: false,
      outsideClickHandler: null,
      dropdownPlacement: 'right'
    };
  },
  computed: {
    isToolbarReversa() {
      return this.appTipo === 'desktop' && this.instancia === 'esquerda';
    },
    toolbarClasses() {
      if (this.appTipo === 'desktop') {
        if (this.isToolbarReversa) {
          return ['justify-content-start', 'flex-row-reverse'];
        }
        if (this.instancia === 'direita') {
          return ['justify-content-start'];
        }
      }
      return ['justify-content-center'];
    },
    groupDirectionClass() {
      return { 'flex-row-reverse': this.isToolbarReversa };
    },
    dropdownMenuStyle() {
      return this.dropdownPlacement === 'left'
        ? { left: '0', right: 'auto' }
        : { right: '0', left: 'auto' };
    },
    mostrarTransferir() {
      return this.appTipo === 'desktop';
    },
    mostrarBotaoPesquisar() {
      return !this.isPesquisaGlobal && this.tipo === 'remoto' && !this.isViewVersoes;
    },
    mostrarBotaoPropriedades() {
      return this.mostrarGrupoPropriedades && this.tipo === 'remoto' && this.view !== 'versoes' && this.view !== 'pesquisa' && !this.isPesquisaGlobal;
    },
    mostrarGrupoPesquisaPropriedades() {
      return this.mostrarBotaoPesquisar || this.mostrarBotaoPropriedades;
    },
    isPesquisaGlobal() {
      return this.funcao === 'pesquisa-global';
    },
    isViewDiretorio() {
      return this.view === 'diretorio';
    },
    isViewPesquisa() {
      return this.view === 'pesquisa';
    },
    isViewCompartilhamentos() {
      return this.view === 'compartilhamentos';
    },
    // View de pesquisa se comporta como diretorio (adminNuvem) ou compartilhamentos (outros)
    isViewDiretorioOuFiltro() {
      return this.isViewDiretorio || (this.isViewPesquisa && this.tipoUsuario === 'adminNuvem');
    },
    isViewCompartilhamentosOuFiltro() {
      return this.isViewCompartilhamentos || (this.isViewPesquisa && this.tipoUsuario !== 'adminNuvem');
    },
    isViewVersoes() {
      return this.view === 'versoes';
    },
    isViewExcluidos() {
      return this.view === 'excluidos';
    },
    dentroCompartilhamento() {
      return this.isViewCompartilhamentos && this.diretorioAtual !== '';
    },
    dentroCompartilhamentoOuFiltro() {
      return this.isViewCompartilhamentosOuFiltro && this.diretorioAtual !== '';
    },
    podeRestaurarExcluido() {
      return this.diretorioAtual === this.diretorioExcluidoRoot;
    },
    // Grupos de visibilidade
    podeAbrirLocal() {
      return this.tipo === 'local' && (this.isViewDiretorioOuFiltro || this.isViewCompartilhamentosOuFiltro);
    },
    podeAbrirRemotoDesktop() {
      return this.appTipo !== 'web' && this.tipo === 'remoto' && this.podeAbrirRemoto;
    },
    // Permissões de ações
    podeNovaPasta() {
      return (this.isViewDiretorioOuFiltro && !this.isViewPesquisa) || this.dentroCompartilhamento || (this.dentroCompartilhamentoOuFiltro && !this.isViewPesquisa);
    },
    podeExcluir() {
      return this.isViewDiretorioOuFiltro || this.isViewVersoes || this.dentroCompartilhamento || this.dentroCompartilhamentoOuFiltro;
    },
    podeRenomear() {
      return this.isViewDiretorioOuFiltro || this.dentroCompartilhamento || this.dentroCompartilhamentoOuFiltro;
    },
    podeRecortar() {
      return !this.isPesquisaGlobal && (this.isViewDiretorioOuFiltro || this.dentroCompartilhamento || this.dentroCompartilhamentoOuFiltro);
    },
    podeCopiar() {
      return this.isViewDiretorioOuFiltro || this.isViewVersoes || this.dentroCompartilhamento || this.dentroCompartilhamentoOuFiltro;
    },
    podeColar() {
      return !this.isPesquisaGlobal && (this.isViewDiretorioOuFiltro || this.dentroCompartilhamento || this.dentroCompartilhamentoOuFiltro);
    },
    podeAbrirRemoto() {
      return this.isViewDiretorioOuFiltro || this.isViewCompartilhamentosOuFiltro;
    },
    podeNavegar() {
      return this.isViewDiretorioOuFiltro || this.isViewCompartilhamentosOuFiltro || this.isViewVersoes || this.isViewExcluidos || this.tipo === 'local';
    },
    podeUpload() {
      return (this.isViewDiretorioOuFiltro && !this.isViewPesquisa) || this.dentroCompartilhamento || (this.dentroCompartilhamentoOuFiltro && !this.isViewPesquisa);
    },
    podeDownload() {
      return this.isViewDiretorioOuFiltro || this.isViewVersoes || this.dentroCompartilhamento || this.dentroCompartilhamentoOuFiltro;
    },
    podeAbrirWeb() {
      return this.appTipo === 'web' && this.tipo !== 'local' && (this.isViewDiretorioOuFiltro || this.isViewCompartilhamentosOuFiltro);
    },
    podeLink() {
      return this.tipo == 'remoto' && (this.isViewDiretorio || this.dentroCompartilhamento);
    },
    mostrarGrupoAcoesPrincipais() {
      return (
        this.podeAbrirLocal ||
        this.podeAbrirRemotoDesktop ||
        this.podeAbrirWeb ||
        (this.appTipo === 'web' && (this.podeUpload || this.podeDownload)) ||
        this.podeLink
      );
    },
    // Visibilidade dos grupos de separadores
    mostrarGrupoEdicao() {
      return this.podeNovaPasta || this.podeExcluir || this.podeRenomear || this.view === 'versoes' || this.view === 'excluidos';
    },
    mostrarGrupoClipboard() {
      return this.podeRecortar || this.podeCopiar || this.podeColar;
    },
    mostrarGrupoPropriedades() {
      return this.tipo === 'remoto' && this.view !== 'versoes' && !this.isPesquisaGlobal;
    },
    mostrarGrupoAcoes() {
      return (
        (!this.isPesquisaGlobal && this.tipo === 'remoto') ||
        this.podeAbrirLocal ||
        this.podeAbrirRemotoDesktop ||
        this.podeAbrirWeb ||
        (this.appTipo === 'web' && (this.podeUpload || this.podeDownload)) ||
        this.podeLink ||
        this.mostrarGrupoPropriedades
      );
    },
    allButtons() {
      const buttons = [];
      
      // GRUPO: Transferir
      if (this.mostrarTransferir) {
        buttons.push({
          id: 'transferir',
          group: 'transferir',
          icon: this.isToolbarReversa ? 'arrow-right' : 'arrow-left',
          title: 'Transferir',
          action: 'transferir',
          disabled: this.selecionadosQtd === 0,
          badge: null,
          showSeparatorAfter: true
        });
      }
      
      // GRUPO: Navegação (pasta acima/anterior não aparecem em versões e excluídos)
      if (this.podeNavegar && !this.isPesquisaGlobal && !this.isViewVersoes && !this.isViewExcluidos) {
        buttons.push({
          id: 'pasta-acima',
          group: 'navegacao',
          icon: 'arrow-up-circle',
          title: 'Pasta Acima',
          action: 'pasta-acima',
          disabled: false,
          badge: null,
          showSeparatorAfter: false
        });
        buttons.push({
          id: 'pasta-anterior',
          group: 'navegacao',
          icon: 'arrow-left-circle',
          title: 'Pasta Anterior',
          action: 'pasta-anterior',
          disabled: false,
          badge: null,
          showSeparatorAfter: false
        });
      }
      
      // Botão Atualizar (sempre visível exceto em pesquisa global que tem tratamento separado)
      if (this.podeNavegar && !this.isPesquisaGlobal) {
        buttons.push({
          id: 'atualizar',
          group: 'navegacao',
          icon: 'arrow-clockwise',
          title: 'Atualizar',
          action: 'atualizar',
          disabled: false,
          badge: null,
          showSeparatorAfter: this.mostrarGrupoClipboard || this.mostrarGrupoEdicao
        });
      }
      
      // Atualizar (pesquisa global sem navegação)
      if (this.isPesquisaGlobal) {
        buttons.push({
          id: 'atualizar',
          group: 'navegacao',
          icon: 'arrow-clockwise',
          title: 'Atualizar',
          action: 'atualizar',
          disabled: false,
          badge: null,
          showSeparatorAfter: false
        });
        buttons.push({
          id: 'abrir-filtro',
          group: 'navegacao',
          icon: 'funnel',
          title: 'Filtro',
          action: 'abrir-filtro',
          disabled: false,
          badge: null,
          showSeparatorAfter: true
        });
      }
      
      // GRUPO: Clipboard
      if (this.mostrarGrupoClipboard) {
        if (this.podeRecortar) {
          buttons.push({
            id: 'recortar',
            group: 'clipboard',
            icon: 'scissors',
            title: 'Recortar',
            action: 'recortar',
            disabled: this.selecionadosQtd === 0,
            badge: this.recortarQtd > 0 ? this.recortarQtd : null,
            showSeparatorAfter: false
          });
        }
        if (this.podeCopiar) {
          buttons.push({
            id: 'copiar',
            group: 'clipboard',
            icon: 'journals',
            title: 'Copiar',
            action: 'copiar',
            disabled: this.selecionadosQtd === 0,
            badge: this.copiarQtd > 0 ? this.copiarQtd : null,
            showSeparatorAfter: false
          });
        }
        if (this.podeColar) {
          buttons.push({
            id: 'colar',
            group: 'clipboard',
            icon: 'clipboard-check',
            title: 'Colar',
            action: 'colar',
            disabled: this.clipboardVazio,
            badge: null,
            showSeparatorAfter: this.mostrarGrupoEdicao
          });
        }
      }
      
      // GRUPO: Edição
      if (this.mostrarGrupoEdicao) {
        if (this.podeNovaPasta) {
          buttons.push({
            id: 'nova-pasta',
            group: 'edicao',
            icon: 'folder-plus',
            title: 'Nova Pasta',
            action: 'nova-pasta',
            disabled: false,
            badge: null,
            showSeparatorAfter: false
          });
        }
        if (this.podeRenomear) {
          buttons.push({
            id: 'renomear',
            group: 'edicao',
            icon: 'cursor-text',
            title: 'Renomear',
            action: 'renomear',
            disabled: this.selecionadosQtd !== 1,
            badge: null,
            showSeparatorAfter: false
          });
        }
        if (this.podeExcluir) {
          buttons.push({
            id: 'excluir',
            group: 'edicao',
            icon: 'trash',
            title: this.view === 'excluidos' ? 'Excluir Definitivamente' : 'Excluir',
            action: 'excluir',
            disabled: this.selecionadosQtd === 0,
            badge: null,
            showSeparatorAfter: false
          });
        }
        if (this.view === 'excluidos' || this.view === 'versoes') {
          buttons.push({
            id: 'restaurar',
            group: 'edicao',
            icon: 'arrow-left-right',
            title: this.view === 'versoes' ? 'Restaurar Versão' : 'Restaurar',
            action: 'restaurar',
            disabled: this.selecionadosQtd === 0,
            badge: null,
            showSeparatorAfter: this.view !== 'excluidos' && this.mostrarGrupoAcoesPrincipais
          });
          //* Botão para excluir permanentemente (apenas na view excluidos)
          if (this.view === 'excluidos') {
            buttons.push({
              id: 'excluir-permanente',
              group: 'edicao',
              icon: 'trash-fill',
              title: 'Excluir Permanentemente',
              action: 'excluir-permanente',
              disabled: this.selecionadosQtd === 0,
              badge: null,
              showSeparatorAfter: this.mostrarGrupoAcoesPrincipais
            });
          }
        } else {
          // Adiciona separador se houver próximo grupo
          const lastButton = buttons[buttons.length - 1];
          if (lastButton && this.mostrarGrupoAcoesPrincipais) {
            lastButton.showSeparatorAfter = true;
          }
        }
      }
      
      // GRUPO: Ações Principais
      if (this.mostrarGrupoAcoesPrincipais) {
        if (this.mostrarBotaoPesquisar) {
          buttons.push({
            id: 'pesquisar',
            group: 'acoes',
            icon: 'search',
            title: 'Pesquisar',
            action: 'abrir-procurar',
            disabled: false,
            badge: null,
            showSeparatorAfter: false
          });
        }
        if (this.podeAbrirLocal) {
          buttons.push({
            id: 'abrir-local',
            group: 'acoes',
            icon: 'youtube',
            title: 'Abrir',
            action: 'abrir-local',
            disabled: this.selecionadosQtd !== 1,
            badge: null,
            showSeparatorAfter: false
          });
        }
        if (this.podeAbrirRemotoDesktop) {
          buttons.push({
            id: 'abrir-arquivo',
            group: 'acoes',
            icon: 'youtube',
            title: 'Abrir',
            action: 'abrir-arquivo',
            disabled: this.selecionadosQtd !== 1 || !this.isSelecionadoArquivo,
            badge: null,
            showSeparatorAfter: false
          });
        }
        if (this.podeAbrirWeb) {
          buttons.push({
            id: 'abrir-arquivo',
            group: 'acoes',
            icon: 'youtube',
            title: 'Abrir',
            action: 'abrir-arquivo',
            disabled: this.selecionadosQtd !== 1 || !this.isSelecionadoArquivo,
            badge: null,
            showSeparatorAfter: false
          });
        }
        if (this.appTipo === 'web' && this.podeUpload) {
          buttons.push({
            id: 'upload',
            group: 'acoes',
            icon: 'cloud-arrow-up',
            title: 'Upload',
            action: 'upload',
            disabled: false,
            badge: null,
            showSeparatorAfter: false
          });
        }
        if (this.appTipo === 'web' && this.podeDownload) {
          buttons.push({
            id: 'download',
            group: 'acoes',
            icon: 'cloud-arrow-down',
            title: 'Download',
            action: 'download',
            disabled: this.selecionadosQtd === 0,
            badge: null,
            showSeparatorAfter: false
          });
        }
        if (this.podeLink) {
          buttons.push({
            id: 'link',
            group: 'acoes',
            icon: 'link-45deg',
            title: 'Link',
            action: 'link',
            disabled: this.selecionadosQtd !== 1,
            badge: null,
            showSeparatorAfter: false
          });
        }

        
        // Adiciona separador se houver próximo grupo
        const lastButton = buttons[buttons.length - 1];
        if (lastButton && this.mostrarGrupoPropriedades) {
          lastButton.showSeparatorAfter = true;
        }
      }
      
      // GRUPO: Propriedades (não pesquisa global)
      if (this.mostrarGrupoPropriedades) {
        buttons.push({
          id: 'propriedades',
          group: 'propriedades',
          icon: 'info-circle',
          title: 'Propriedades',
          action: 'propriedades',
          disabled: false,
          badge: null,
          showSeparatorAfter: this.isPesquisaGlobal
        });
      }
      
      // Exportar (pesquisa global)
      if (this.isPesquisaGlobal) {
        buttons.push({
          id: 'exportar',
          group: 'exportar',
          icon: 'box-arrow-up',
          title: 'Exportar',
          action: 'exportar',
          disabled: this.itensTotal === 0,
          badge: null,
          showSeparatorAfter: false
        });
      }
      
      return buttons;
    }
  },
  methods: {
    setupObservers() {
      if (!this.$refs.toolbarContainer) return;
      
      // ResizeObserver para detectar mudanças de tamanho do container
      this.resizeObserver = new ResizeObserver(() => {
        this.debouncedCheckOverflow();
      });
      this.resizeObserver.observe(this.$refs.toolbarContainer);
      
      // Verifica overflow inicial após um pequeno delay
      setTimeout(() => {
        this.checkOverflow();
      }, 150);
    },
    debouncedCheckOverflow() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      
      this.debounceTimer = setTimeout(() => {
        this.checkOverflow();
      }, 50);
    },
    checkOverflow() {
      if (!this.$refs.toolbarContainer || this.isCalculating) {
        return;
      }
      
      const container = this.$refs.toolbarContainer;
      const buttons = this.allButtons;
      
      if (buttons.length === 0) {
        this.visibleButtons = [];
        this.overflowButtons = [];
        this.hasOverflow = false;
        return;
      }
      
      this.isCalculating = true;
      
      // SEMPRE mostra todos os botões primeiro para medir corretamente
      this.visibleButtons = buttons;
      this.overflowButtons = [];
      this.hasOverflow = false;
      
      this.$nextTick(() => {
        // Procura o card-body que é o container real
        let cardBody = container.closest('.card-body');
        let containerWidth = 0;
        
        if (cardBody) {
          // Usa o clientWidth do card-body (sem padding/border)
          const cardStyle = window.getComputedStyle(cardBody);
          const paddingLeft = parseFloat(cardStyle.paddingLeft) || 0;
          const paddingRight = parseFloat(cardStyle.paddingRight) || 0;
          containerWidth = cardBody.clientWidth - paddingLeft - paddingRight;
        } else {
          // Fallback para o parent direto
          const parentCol = container.parentElement;
          containerWidth = parentCol ? parentCol.clientWidth : container.offsetWidth;
        }
        
        const toolbarWidth = container.offsetWidth;
        
        // Se container não tem largura ainda, aguarda
        if (containerWidth === 0) {
          this.isCalculating = false;
          return;
        }
        
        const buttonElements = container.querySelectorAll('.btn-group-custom');
        
        if (buttonElements.length === 0) {
          this.isCalculating = false;
          return;
        }
        
        const overflowButtonWidth = 60;
        const safetyMargin = 100; // Margem grande para garantir que aparece antes
        let totalWidth = 0;
        
        // Calcula largura total de TODOS os botões + separadores + gaps
        for (let i = 0; i < buttonElements.length; i++) {
          const btnWidth = buttonElements[i].offsetWidth || 0;
          totalWidth += btnWidth;
          
          // Adiciona largura do separador se existir
          if (buttons[i]?.showSeparatorAfter) {
            const sepElement = buttonElements[i].nextElementSibling;
            if (sepElement && sepElement.classList.contains('toolbar-separator')) {
              const sepWidth = sepElement.offsetWidth || 0;
              totalWidth += sepWidth;
            }
          }
          
          // Adiciona gap CSS entre botões (exceto o último)
          if (i < buttonElements.length - 1) {
            totalWidth += 2; // gap do CSS
          }
        }
        
        // Se todos cabem com boa margem de segurança
        if (totalWidth + safetyMargin <= containerWidth) {
          this.visibleButtons = buttons.map(btn => ({ ...btn }));
          this.overflowButtons = [];
          this.hasOverflow = false;
          this.isCalculating = false;
          return;
        }
        
        // Precisa de overflow - calcula quantos cabem
        const availableWidth = containerWidth - overflowButtonWidth - safetyMargin;
        let currentWidth = 0;
        let visibleCount = 0;
        
        for (let i = 0; i < buttonElements.length; i++) {
          const btnWidth = buttonElements[i].offsetWidth || 0;
          
          // Verifica se este botão + seu separador cabem
          let itemWidth = btnWidth;
          
          // Se não é o último botão, considera o separador sempre (mesmo que não tenha)
          // para ter uma margem de segurança entre botões
          if (i < buttonElements.length - 1) {
            if (buttons[i]?.showSeparatorAfter) {
              const sepElement = buttonElements[i].nextElementSibling;
              if (sepElement && sepElement.classList.contains('toolbar-separator')) {
                itemWidth += sepElement.offsetWidth || 0;
              }
            } else {
              // Adiciona margem de segurança entre botões (gap)
              itemWidth += 2;
            }
          }
          
          if (currentWidth + itemWidth <= availableWidth) {
            currentWidth += itemWidth;
            visibleCount++;
          } else {
            break;
          }
        }
        
        // Garante pelo menos um no overflow
        if (visibleCount === buttons.length) {
          visibleCount = Math.max(0, buttons.length - 1);
        }
        
        if (visibleCount > 0) {
          // Cria cópias dos botões para não modificar o original
          this.visibleButtons = buttons.slice(0, visibleCount).map(btn => ({ ...btn }));
          this.overflowButtons = buttons.slice(visibleCount).map(btn => ({ ...btn }));
          
          // Remove o separador do último botão visível
          if (this.visibleButtons.length > 0) {
            this.visibleButtons[this.visibleButtons.length - 1].showSeparatorAfter = false;
          }
          
          this.hasOverflow = true;
        } else {
          this.visibleButtons = [];
          this.overflowButtons = buttons.map(btn => ({ ...btn }));
          this.hasOverflow = true;
        }
        
        this.isCalculating = false;
      });
    },
    toggleDropdown(event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      const menu = this.$refs.dropdownMenu;
      if (!menu) {
        return;
      }
      const isOpen = menu.classList.contains('show');
      if (isOpen) {
        menu.classList.remove('show');
        if (this.outsideClickHandler) {
          document.removeEventListener('click', this.outsideClickHandler);
          this.outsideClickHandler = null;
        }
      } else {
        this.updateDropdownPlacement();
        menu.classList.add('show');
        this.outsideClickHandler = (e) => {
          if (!menu.contains(e.target) && !this.$refs.overflowButton?.contains(e.target)) {
            menu.classList.remove('show');
            document.removeEventListener('click', this.outsideClickHandler);
            this.outsideClickHandler = null;
          }
        };
        document.addEventListener('click', this.outsideClickHandler);
      }
    },
    updateDropdownPlacement() {
      const button = this.$refs.overflowButton;
      const menu = this.$refs.dropdownMenu;
      if (!button || !menu) {
        this.dropdownPlacement = 'right';
        return;
      }
      const menuWidth = menu.offsetWidth || 220;
      const rect = button.getBoundingClientRect();
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const spaceRight = viewportWidth - rect.right;
      const spaceLeft = rect.left;
      if (spaceRight >= menuWidth || spaceRight >= spaceLeft) {
        this.dropdownPlacement = 'left';
      } else {
        this.dropdownPlacement = 'right';
      }
    },
    handleButtonClick(action) {
      this.$emit(action);
      // Fecha o dropdown após click
      if (this.$refs.dropdownMenu) {
        this.$refs.dropdownMenu.classList.remove('show');
      }
      if (this.outsideClickHandler) {
        document.removeEventListener('click', this.outsideClickHandler);
        this.outsideClickHandler = null;
      }
    },
    getIconSvg(iconName) {
      const icons = {
        'arrow-right': '<path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>',
        'arrow-left': '<path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>',
        'arrow-up-circle': '<path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"/>',
        'arrow-left-circle': '<path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>',
        'arrow-clockwise': '<path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/><path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>',
        'scissors': '<path d="M3.5 3.5c-.614-.884-.074-1.962.858-2.5L8 7.226 11.642 1c.932.538 1.472 1.616.858 2.5L8.81 8.61l1.556 2.661a2.5 2.5 0 1 1-.794.637L8 9.73l-1.572 2.177a2.5 2.5 0 1 1-.794-.637L7.19 8.61 3.5 3.5zm2.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm7 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"/>',
        'journals': '<path d="M5 0h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1H1a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1H3a2 2 0 0 1 2-2z"/><path d="M1 6v-.5a.5.5 0 0 1 1 0V6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V9h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 2.5v.5H.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H2v-.5a.5.5 0 0 0-1 0z"/>',
        'clipboard-check': '<path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/><path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>',
        'folder-plus': '<path d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z"/><path d="M13.5 10a.5.5 0 0 1 .5.5V12h1.5a.5.5 0 1 1 0 1H14v1.5a.5.5 0 1 1-1 0V13h-1.5a.5.5 0 0 1 0-1H13v-1.5a.5.5 0 0 1 .5-.5z"/>',
        'cursor-text': '<path d="M5 2a.5.5 0 0 1 .5-.5c.862 0 1.573.287 2.06.566.174.099.321.198.44.286.119-.088.266-.187.44-.286A4.17 4.17 0 0 1 10.5 1.5a.5.5 0 0 1 0 1c-.638 0-1.177.213-1.564.434a3.5 3.5 0 0 0-.436.294V7.5H9a.5.5 0 0 1 0 1h-.5v4.272c.1.08.248.187.436.294.387.221.926.434 1.564.434a.5.5 0 0 1 0 1 4.17 4.17 0 0 1-2.06-.566A5 5 0 0 1 8 13.65a5 5 0 0 1-.44.285 4.17 4.17 0 0 1-2.06.566.5.5 0 0 1 0-1c.638 0 1.177-.213 1.564-.434.188-.107.335-.214.436-.294V8.5H7a.5.5 0 0 1 0-1h.5V3.228a3.5 3.5 0 0 0-.436-.294A3.17 3.17 0 0 0 5.5 2.5.5.5 0 0 1 5 2m2.648 10.645"/>',
        'pen': '<path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>',
        'trash': '<path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>',
        'trash-fill': '<path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>',
        'arrow-counterclockwise': '<path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"/><path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"/>',
        'arrow-left-right': '<path fill-rule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"/>',
        'search': '<path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>',
        'funnel': '<path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z"/>',
        'folder2-open': '<path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v.64c.57.265.94.876.856 1.546l-.64 5.124A2.5 2.5 0 0 1 12.733 15H3.266a2.5 2.5 0 0 1-2.481-2.19l-.64-5.124A1.5 1.5 0 0 1 1 6.14V3.5zM2 6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3H2.5a.5.5 0 0 0-.5.5V6zm-.367 1a.5.5 0 0 0-.496.562l.64 5.124A1.5 1.5 0 0 0 3.266 14h9.468a1.5 1.5 0 0 0 1.489-1.314l.64-5.124A.5.5 0 0 0 14.367 7H1.633z"/>',
        'youtube': '<path d="M8.051 1.999h-.102C6.175 2 4.398 2.043 3.09 2.27c-.68.12-1.215.542-1.377 1.248C1.5 4.68 1.5 8 1.5 8s0 3.32.213 4.482c.163.706.698 1.128 1.377 1.248 1.308.227 3.085.271 4.859.271 1.774 0 3.551-.044 4.859-.27.68-.121 1.215-.543 1.377-1.249C14.5 11.32 14.5 8 14.5 8s0-3.319-.214-4.482c-.162-.706-.697-1.128-1.377-1.248C11.6 2.043 9.823 2 8.051 1.999zM6.4 5.508l3.955 2.491-3.955 2.49V5.508z"/>',
        'cloud-arrow-up': '<path fill-rule="evenodd" d="M7.646 5.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2z"/><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"/>',
        'cloud-arrow-down': '<path fill-rule="evenodd" d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708l2 2z"/><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"/>',
        'link-45deg': '<path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/><path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>',
        'info-circle': '<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>',
        'box-arrow-up': '<path fill-rule="evenodd" d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"/><path fill-rule="evenodd" d="M7.646.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 1.707V10.5a.5.5 0 0 1-1 0V1.707L5.354 3.854a.5.5 0 1 1-.708-.708l3-3z"/>',
        'three-dots': '<path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>'
      };
      
      return icons[iconName] || '';
    }
  },
  watch: {
    // Recalcula quando a lista de botões mudar (por mudanças nas props)
    allButtons: {
      handler() {
        this.debouncedCheckOverflow();
      },
      deep: true
    }
  },
  mounted() {
    // Inicializa com todos os botões visíveis
    this.visibleButtons = this.allButtons;
    this.overflowButtons = [];
    
    // Configura os observers
    this.$nextTick(() => {
      this.setupObservers();
    });
  },
  beforeUnmount() {
    // Limpa o observer
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
    if (this.outsideClickHandler) {
      document.removeEventListener('click', this.outsideClickHandler);
      this.outsideClickHandler = null;
    }
  }
};
</script>

<style scoped>
.toolbar-botoes {
  display: flex;
  align-items: center;
  gap: 2px;
  overflow: visible;
  flex-wrap: nowrap;
}

.toolbar-separator {
  width: 1px;
  height: 24px;
  background-color: #e4e6ef;
  margin: 0 8px;
  flex-shrink: 0;
}

.btn-group-custom {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.btn-group-custom.dropdown {
  z-index: 1000;
}

.toolbar-button-wrapper {
  flex-shrink: 0;
}

.btn-group-custom.flex-row-reverse .me-2 {
  margin-right: 0 !important;
  margin-left: 0.5rem !important;
}

.btn-group-inner {
  display: flex;
  align-items: center;
}

/* Dropdown menu styles */
.btn-group.dropdown {
  position: relative !important;
}

.overflow-trigger {
  border-top-right-radius: 0.475rem;
  border-bottom-right-radius: 0.475rem;
}

.toolbar-botoes .dropdown-menu {
  max-height: 400px !important;
  overflow-y: auto !important;
  z-index: 10000 !important;
  position: absolute !important;
  top: 100% !important;
  display: none !important;
  background: white !important;
  background-color: white !important;
  border: 1px solid #e4e6ef !important;
  border-radius: 0.475rem !important;
  box-shadow: 0 0 50px 0 rgba(82, 63, 105, 0.15) !important;
  min-width: 200px !important;
  width: auto !important;
  margin-top: 0.5rem !important;
  padding: 0.5rem 0 !important;
  list-style: none !important;
  visibility: visible !important;
  opacity: 1 !important;
  transform: none !important;
}

.toolbar-botoes .dropdown-menu.show {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.dropdown-item {
  padding: 0.5rem 1rem;
}

.dropdown-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.dropdown-item.border-bottom {
  border-bottom: 1px solid #e4e6ef;
  margin-bottom: 0.25rem;
  padding-bottom: 0.75rem;
}

.btn-group-inner.flex-row-reverse .me-2 {
  margin-right: 0 !important;
  margin-left: 0.5rem !important;
}
</style>
